module.exports = __webpack_public_path__ + "media/img/why-vendor/notfound-60c342f79f7e6b451b04299a78be0a8c.png";